<div *ngIf="slidePanel"
     [@slide]="slideState"
     (@slide.start)="onSlideStart($event)"
     (@slide.done)="onSlideEnd($event)"
     class="slide-container">
  <ng-container *ngIf="templates[Side.LEFT]" [ngTemplateOutlet]="templates[Side.LEFT]"></ng-container>
  <ng-container *ngIf="templates[Side.RIGHT]" [ngTemplateOutlet]="templates[Side.RIGHT]"></ng-container>
</div>